import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IPrSFilter } from 'src/@types/SearchFilterTypes';
import { Page } from 'src/components/Page';

import NoticeGrid from './NoticeGrid';
import SearchForm from './SearchForm';

/** * ## Notice 설명 * */
export const Notice = observer(() => {
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<IPrSFilter>>({});
  // 목록 검색
  const onSearch = (data: IPrSFilter) => {
    setSearchData(data);
  };
  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <NoticeGrid searchData={searchData} />
    </Page>
  );
});
export default Notice;
